module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Vynil-ef2aa310b6634e8f92187eedc7e1054a.svg";